import { render, staticRenderFns } from "./TableWithFilter.vue?vue&type=template&id=27f85ab1"
import script from "./TableWithFilter.vue?vue&type=script&lang=ts"
export * from "./TableWithFilter.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports